/**
 * Auto generated file using cli command
 * _> cronos front-enum
 * !! DO NOT EDIT THIS FILE MANUALLY !!
 * Manual changes will be overwritten
 */

export enum CONTRACT_TYPE {
	None = 0,
	Initial = 1,
	Prolongation = 2,
	Modification = 3,
}
